module.exports = __webpack_public_path__ + "img/Premium FocusStart.3fd44249.png";